export default __webpack_public_path__ + "static/indian1-wide-64fe60ac70b27ed6e6a5fc5810fabc34.jpg";